/* import __COLOCATED_TEMPLATE__ from './stacked-bar-chart-legend-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();